import axios from "axios";

export const CurrencyRateService = {
  async getAll() {
    const response = await axios.get(
      `${process.env.REACT_APP_STRAPI_URL}/api/currency-rates`
    );

    const res = response.data.data;
    // console.log(res);

    const data = res.map((item) => ({
      id: item.id,
      base_ccy: item.attributes.base_ccy,
      city: item.attributes.city,
      ccy: item.attributes.ccy,
      sale: Number(item.attributes.sale).toFixed(2),
      buy: Number(item.attributes.buy).toFixed(2),
      flag: item.attributes.flag,
      createdAt: new Date(item.attributes.createdAt).toLocaleString(),
      updatedAt: new Date(item.attributes.updatedAt).toLocaleString(),
      publishedAt: new Date(item.attributes.publishedAt).toLocaleString(),
    }));

    return data;
  },

  async getById(id) {
    const response = await axios.get(
      `${process.env.REACT_APP_STRAPI_URL}/api/currency-rates/${id}`
    );
    const res = response.data.data;

    const data = {
      id: res.id,
      base_ccy: res.attributes.base_ccy,
      city: res.attributes.city,
      ccy: res.attributes.ccy,
      sale: res.attributes.sale,
      buy: res.attributes.buy,
      flag: res.attributes.flag,
    };

    return data;
  },

  async create(data, jwt) {
    const response = await axios.post(
      `${process.env.REACT_APP_STRAPI_URL}/api/currency-rates`,
      { data },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${jwt}`,
        },
      }
    );

    return response.data;
  },

  async update(id, data, jwt) {   
    const response = await axios.put(
      `${process.env.REACT_APP_STRAPI_URL}/api/currency-rates/${id}`,
      { data },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${jwt}`,
        },
      }
    );

    return response.data;
  },

  async delete(id, jwt) {
    const response = await axios.delete(
      `${process.env.REACT_APP_STRAPI_URL}/api/currency-rates/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${jwt}`,
        },
      }
    );

    return response.data;
  },
};
